import { Box } from "@mui/material";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { Plus } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
import { SPACING } from "../../common/constants/spacing";

function CreateNewProjectCard() {
  const { t } = useTranslation("projects");

  return (
    <Grid size={{ xs: 12, md: 4 }}>
      <Card
        sx={{
          height: "100%",
        }}
      >
        <CardActionArea
          component={RouterLink}
          to="/projects/create"
          sx={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            px: 3,
            py: 5,
            textDecoration: "none",
          }}
        >
          <Box sx={{ color: "primary.main", mb: SPACING.xs }}>
            <Plus size={48} />
          </Box>
          <Typography
            variant="subtitle1"
            color="text.secondary"
            textAlign="center"
            sx={{ userSelect: "none" }}
          >
            {t("myProjects.addProject")}
          </Typography>
        </CardActionArea>
      </Card>
    </Grid>
  );
}

export default CreateNewProjectCard;
